"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BlackLogo = _interopRequireDefault(require("../../../assets/images/BlackLogo.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetSvgLogo = () => {
  return /*#__PURE__*/_react.default.createElement("img", {
    src: _BlackLogo.default,
    alt: "SingularityNET"
  });
};
var _default = exports.default = SnetSvgLogo;